export enum ENewbuildingInfrastructures {
  /** Школа */
  School = 1,
  /** Детский сад */
  Kindergarten = 2,
  /** Поликлиника */
  Polyclinic = 3,
  /** Детские площадки */
  Children = 4,
  /** Спортивные площадки */
  Sport = 5,
  /** Места для отдыха */
  Recreation = 6,
  /** Площадки для выгула собак */
  Dogs = 7,
  /** Супермаркет */
  Supermarket = 8,
  /** Рестораны */
  Restaurant = 9,
  /** Фитнес-центр */
  Fitness = 10,
  /** SPA-центр */
  Spa = 11,
  /** Бассейн */
  Pool = 12,
  /** Пункты бытового обслуживания */
  Domestic = 13,
  /** Коммерческие объекты */
  Commerce = 14,
  /** Офисы */
  Offices = 15,
}
